/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: #4ab4db;
  }
`
export default class OddsIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" css={Color}>
          <path
            d="M24,48A24,24,0,1,1,48,24,24.027,24.027,0,0,1,24,48ZM7.6,15.1c-1.044,0-1.6,1.16-1.6,2,0,.8.426,2,1.6,2H8.7V31.9a1.9,1.9,0,0,0,2,2,1.937,1.937,0,0,0,2-2V17a1.721,1.721,0,0,0-1.6-1.9ZM29.049,31h0l-.149.2a.353.353,0,0,1-.051.151.354.354,0,0,0-.05.15v.3a2,2,0,0,0,1.9,2h9.6a1.96,1.96,0,0,0,.8-.1l.2-.1a1.889,1.889,0,0,0,1.1-1.8v-.4c0-.1,0-.2-.1-.2l-.05-.2-.15-.2a2.084,2.084,0,0,0-1.6-.8H35.4c.447-.521.938-1.055,1.442-1.6,2.184-2.375,4.658-5.066,4.658-8a4.9,4.9,0,0,0-.1-1.2A6.031,6.031,0,0,0,35.3,14,6.308,6.308,0,0,0,29,20.3c0,2.649,1.44,3.2,2.3,3.3a1.69,1.69,0,0,0,1.8-1.4,2.019,2.019,0,0,0-.124-.912A3.379,3.379,0,0,1,32.8,20.3a2.535,2.535,0,0,1,2.5-2.5,2.478,2.478,0,0,1,2.5,2.7,3.947,3.947,0,0,1-1.118,2.274L36.5,23a38.844,38.844,0,0,1-4.131,4.466C31.4,28.406,30.4,29.38,29.5,30.4a1.379,1.379,0,0,0-.3.4l-.15.2ZM21.1,26.5h0l1.4,1.4a1.452,1.452,0,0,0,2,0,1.229,1.229,0,0,0,0-1.9l-1.4-1.4,1.4-1.4a1.4,1.4,0,0,0,0-1.9,1.393,1.393,0,0,0-1.9,0l-1.4,1.4-1.4-1.4a1.344,1.344,0,0,0-1.9,1.9l1.4,1.4L17.8,26a1.4,1.4,0,0,0,0,1.9,1.393,1.393,0,0,0,1.9,0l1.4-1.4Z"
            fill="#4ab4db"
          />
        </svg>
      </Fragment>
    )
  }
}
